import { type ExperimentValue } from '@stone-payments/experiment/src/lib/types'

export enum WithdrawalContentEnum {
  AvailableBalance = 'available_balance',
  SellAmount = 'sell_amount',
  ProductName = 'product_name',
  RedemptionCost = 'redemption_cost',
  GrossAmount = 'gross_amount',
  NetAmount = 'net_amount'
}

export type WithdrawalContent = {
  title?: string
  input_label?: string
  continue_button?: string
  input_error_text?: string
  input_support_text?: string
  buyback_section_title?: string
  buyback_gross_label?: string
  buyback_gross_tooltip?: string
  buyback_cost_label?: string
  buyback_cost_value?: string
  buyback_cost_tooltip?: string
  buyback_net_label?: string
  buyback_net_tooltip?: string
}

export type MarketWithdrawalExperimentPayload = WithdrawalContent & {
  ignore_default_content?: boolean
}

export const defaultWithdrawalContent: Required<WithdrawalContent> = {
  title: 'Quanto você quer resgatar?',
  input_label: 'Valor do resgate líquido',
  continue_button: 'Continuar',
  input_error_text: 'Seu saldo disponível é de {available_balance}',
  input_support_text: 'Disponível: {available_balance}',
  buyback_section_title: 'Confira as condições',
  buyback_gross_label: 'Valor do resgate',
  buyback_gross_tooltip: 'Valor total que será resgatado do seu CDB.',
  buyback_cost_label: 'Custo do resgate antecipado',
  buyback_cost_value: '- {redemption_cost}',
  buyback_cost_tooltip: 'Valor calculado para o resgate antes do vencimento.',
  buyback_net_label: 'Valor do resgate líquido',
  buyback_net_tooltip: 'Valor que estará disponível na conta, após o resgate.'
}

export const defaultMarketWithdrawalExperimentPayload: ExperimentValue<MarketWithdrawalExperimentPayload> = {
  value: 'control',
  payload: defaultWithdrawalContent
}
